var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1510_20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8.5,
    fill: "#213657"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8,
    stroke: "url(#paint0_linear_1510_20)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5207 48V46.5122L46.0004 43.9581C46.4881 43.4539 46.8559 43.0571 47.1039 42.7678C47.3601 42.4703 47.5337 42.2223 47.6247 42.0239C47.7238 41.8255 47.7734 41.6313 47.7734 41.4412C47.7734 41.1023 47.6618 40.8378 47.4387 40.6477C47.2238 40.4493 46.951 40.3501 46.6204 40.3501C46.2815 40.3501 45.9798 40.4493 45.7153 40.6477C45.4508 40.8378 45.2565 41.1312 45.1325 41.528L43.4587 40.9824C43.5579 40.503 43.7646 40.0856 44.0787 39.7302C44.3928 39.3748 44.773 39.102 45.2193 38.9119C45.6657 38.7135 46.1327 38.6143 46.6204 38.6143C47.232 38.6143 47.7693 38.7218 48.2322 38.9367C48.6951 39.1516 49.0546 39.4533 49.3108 39.8418C49.5671 40.2303 49.6952 40.6849 49.6952 41.2056C49.6952 41.5362 49.6373 41.8627 49.5216 42.1851C49.4059 42.4992 49.2282 42.8215 48.9885 43.1522C48.757 43.4745 48.4554 43.8258 48.0834 44.2061L45.9632 46.3882H49.782V48H43.5207Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1510_20",
    x: 0,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1510_20"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1510_20",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1510_20",
    x1: 46.5,
    y1: 35,
    x2: 46.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DC7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465FAF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepImage2);
export default __webpack_public_path__ + "static/media/StepImage2.cda23da7611eaecc2da8181980f6f7ab.svg";
export { ForwardRef as ReactComponent };